if (!customElements.get('localization-form')) {
  (function($) {
    $.fn.localizationForm = function() {
      return this.each(function() {
        const $this = $(this);
        const mql = window.matchMedia('(min-width: 750px)');
        const $header = $('.header-wrapper');
        const elements = {
          $input: $this.find('input[name="locale_code"], input[name="country_code"]'),
          $button: $this.find('button.localization-form__select'),
          $panel: $this.find('.disclosure__list-wrapper'),
          $search: $this.find('input[name="country_filter"]'),
          $closeButton: $this.find('.country-selector__close-button'),
          $resetButton: $this.find('.country-filter__reset-button'),
          $searchIcon: $this.find('.country-filter__search-icon'),
          $liveRegion: $this.find('#sr-country-search-results')
        };

        // Event bindings
        $this.on('keyup', onContainerKeyUp);
        $this.on('keydown', onContainerKeyDown);
        $this.on('focusout', closeSelector);
        elements.$button.on('click', openSelector);
        elements.$search.on({
          keyup: filterCountries,
          focus: onSearchFocus,
          blur: onSearchBlur,
          keydown: onSearchKeyDown
        });
        elements.$closeButton.on('click', hidePanel);
        elements.$resetButton.on({
          click: resetFilter,
          mousedown: function(e) { e.preventDefault(); }
        });
        $this.find('a').on('click', onItemClick);

        function hidePanel() {
          elements.$button.attr('aria-expanded', 'false');
          elements.$panel.attr('hidden', true);
          if (elements.$search.length) {
            elements.$search.val('').attr('aria-activedescendant', '');
            filterCountries();
          }
          $('body').removeClass('overflow-hidden-mobile');
          $('.menu-drawer').removeClass('country-selector-open');
          $header[0].preventHide = false;
        }

        function onContainerKeyDown(e) {
          const $focusableItems = $this.find('a').filter(function() {
            return !$(this).parent().hasClass('hidden');
          });
          const focusedItemIndex = $focusableItems.index(document.activeElement);
          let $itemToFocus;

          switch (e.code.toUpperCase()) {
            case 'ARROWUP':
              e.preventDefault();
              $itemToFocus = focusedItemIndex > 0 ? 
                $focusableItems.eq(focusedItemIndex - 1) : 
                $focusableItems.last();
              $itemToFocus.focus();
              break;
            case 'ARROWDOWN':
              e.preventDefault();
              $itemToFocus = focusedItemIndex < $focusableItems.length - 1 ? 
                $focusableItems.eq(focusedItemIndex + 1) : 
                $focusableItems.first();
              $itemToFocus.focus();
              break;
          }

          if (!elements.$search.length) return;

          setTimeout(() => {
            const newIndex = $focusableItems.index(document.activeElement);
            elements.$search.attr('aria-activedescendant', 
              newIndex > -1 ? $focusableItems.eq(newIndex).attr('id') : '');
          });
        }

        function onContainerKeyUp(e) {
          e.preventDefault();
          switch (e.code.toUpperCase()) {
            case 'ESCAPE':
              if (elements.$button.attr('aria-expanded') === 'false') return;
              hidePanel();
              e.stopPropagation();
              elements.$button.focus();
              break;
            case 'SPACE':
              if (elements.$button.attr('aria-expanded') === 'true') return;
              openSelector();
              break;
          }
        }

        function onItemClick(e) {
          e.preventDefault();
          const $form = $this.find('form');
         
          elements.$input.val($(this).data('value'));
          if ($form.length) $form.submit();
        }
        // $('.language-selector1 .disclosure__item').click(function(){
        //    e.preventDefault();
        //   const $form = $this.find('form');
          
        //   elements.$input.val($(this).data('value'));
        //   if ($form.length) $form.submit();
        //  })

        function openSelector() {
          elements.$button.focus();
          elements.$panel.attr('hidden', function(i, attr) { return !attr; });
          elements.$button.attr('aria-expanded', 
            elements.$button.attr('aria-expanded') === 'false' ? 'true' : 'false');
          if (!$('body').hasClass('overflow-hidden-tablet')) {
            $('body').addClass('overflow-hidden-mobile');
          }
          if (elements.$search.length && mql.matches) {
            elements.$search.focus();
          }
          if ($this.data('prevent-hide')) {
            $header[0].preventHide = true;
          }
          $('.menu-drawer').addClass('country-selector-open');
        }

        function closeSelector(e) {
          if ($(e.target).hasClass('country-selector__overlay') ||
              !$this.is(e.target) && !$this.has(e.target).length &&
              !$this.is(e.relatedTarget) && !$this.has(e.relatedTarget).length) {
            hidePanel();
          }
        }

        function normalizeString(str) {
          return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
        }

        function filterCountries() {
          const searchValue = normalizeString(elements.$search.val());
          const $popularCountries = $this.find('.popular-countries');
          const $allCountries = $this.find('a');
          let visibleCountries = $allCountries.length;

          elements.$resetButton.toggleClass('hidden', !searchValue);
          $popularCountries.toggleClass('hidden', !!searchValue);

          $allCountries.each(function() {
            const countryName = normalizeString($(this).find('.country').text());
            const $parent = $(this).parent();
            if (countryName.indexOf(searchValue) > -1) {
              $parent.removeClass('hidden');
              visibleCountries++;
            } else {
              $parent.addClass('hidden');
              visibleCountries--;
            }
          });

          if (elements.$liveRegion.length) {
            elements.$liveRegion.html(
              window.accessibilityStrings.countrySelectorSearchCount.replace('[count]', visibleCountries)
            );
          }

          $this.find('.country-selector, .country-selector__list').scrollTop(0);
        }

        function resetFilter(e) {
          e.stopPropagation();
          elements.$search.val('');
          filterCountries();
          elements.$search.focus();
        }

        function onSearchFocus() {
          elements.$searchIcon.addClass('country-filter__search-icon--hidden');
        }

        function onSearchBlur() {
          if (!elements.$search.val()) {
            elements.$searchIcon.removeClass('country-filter__search-icon--hidden');
          }
        }

        function onSearchKeyDown(e) {
          if (e.code.toUpperCase() === 'ENTER') {
            e.preventDefault();
          }
        }
      });
    };

    // Initialize
    $('localization-form').localizationForm();
  })(jQuery);
}